import { render, staticRenderFns } from "./Bestaetigung.vue?vue&type=template&id=ba6afa2a&scoped=true&"
import script from "./Bestaetigung.vue?vue&type=script&lang=js&"
export * from "./Bestaetigung.vue?vue&type=script&lang=js&"
import style0 from "./Bestaetigung.vue?vue&type=style&index=0&id=ba6afa2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6afa2a",
  null
  
)

export default component.exports